import { SmoothScroll } from "../components/site/SmoothScroll";
import { Noise } from "../components/site/Noise";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { BrandMarquee } from "../components/site/Marquee";
import { Categories } from "../components/site/Categories";
import { Recursos } from "../components/site/Recursos";
import { HowItWorks } from "../components/site/HowItWorks";
import { Lojistas } from "../components/site/Lojistas";
import { DownloadCta } from "../components/site/DownloadCta";
import { Faq } from "../components/site/Faq";
import { Footer } from "../components/site/Footer";
import { WhatsappButton } from "../components/site/WhatsappButton";

export default function Landing() {
  return (
    <SmoothScroll>
      <Noise />
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <Categories />
        <Recursos />
        <HowItWorks />
        <Lojistas />
        <DownloadCta />
        <Faq />
      </main>
      <Footer />
      <WhatsappButton />
    </SmoothScroll>
  );
}
